/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Location } from '@angular/common';
import { AppState } from 'src/app/services/app-state.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { OrganizationAppEditorComponent } from 'src/app/modules/organizations/components/organization-app-editor/organization-app-editor.component';
import { API_SETTINGS } from '@touchplan/strings';
import { OrganizationService } from 'src/app/modules/organizations/services/organization.service';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Component({
	selector: 'nav-bar-account',
	templateUrl: './nav-bar-account.component.html',
	styles: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavBarAccountComponent implements OnInit {
	public appStrings = { API_SETTINGS };
	public isOrgAdmin$: Observable<boolean>;

	constructor(
		public appState: AppState,
		public router: Router,
		protected dialog: MatDialog,
		public location: Location,
		private authService: AuthService,
		private organizationService: OrganizationService
	) {}

	public ngOnInit() {
		this.isOrgAdmin$ = this.organizationService.isOrgAdmin$;
	}

	public goBack(): void {
		this.location.back();
	}

	public goToDashboard(): void {
		console.trace('-----Router Debugger-----');
		this.router.navigate(['projects']);
	}

	public logout(): void {
		this.authService.logout();
	}

	public goToMobile(): void {
		window.open('https://m.touchplan.io', '_self');
	}

	public openAPISettings() {
		OrganizationAppEditorComponent.openOrganizationApiSettings(this.dialog);
	}
}
